import { component } from "picoapp";

export default component((node) => {
  window.addEventListener("option-change:color", (event) => {
    const eventValue = event.detail.value;
    const imageContainer1 = node.querySelectorAll("[data-image1]");
    const imageContainer2 = node.querySelectorAll("[data-image2]");

    if (eventValue) {
      imageContainer2.forEach((el) => (el.style.opacity = "100%"));
      imageContainer1.forEach((el) => (el.style.opacity = "0"));
    } else {
      imageContainer1.forEach((el) => (el.style.opacity = "100%"));
      imageContainer2.forEach((el) => (el.style.opacity = "0"));
    }
  });
});
